import { RestingState } from "../controllers/states/being/RestingState";
import { Direction } from "../models/constants";
import { randomBeingName } from "../assets/text/being-names";

export type BeingState = string;

export class Being {
    public state: BeingState;
    public health: number;
    public x: number;
    public z: number;
    public name: string;
    public moveDirection: Direction | null = null;
    public directionTicks: number = 0;
    public restTicks: number = 0;
    public hasImmunity: boolean = true;

    /**
     * @param x - World-space X position.
     * @param z - World-space Z position.
     * @param state - Initial state (defaults to `Resting`).
     * @param health - Initial health in [0, 1] (defaults to 1.0).
     * @param name - Display name (defaults to a random quirky British name).
     */
    constructor(x: number, z: number, state: BeingState = RestingState.stateName, health = 1.0, name: string = randomBeingName()) {
        this.x = x;
        this.z = z;
        this.state = state;
        this.health = health;
        this.name = name;
    }

    /** Sets health, clamped to [0, 1]. */
    public setHealth(value: number): void {
        this.health = Math.min(1.0, Math.max(0, value));
    }

    /** Translates position by the given offsets. */
    public translate(dx: number, dz: number): void {
        this.x += dx;
        this.z += dz;
    }
}
